var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackendIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.292,
    height: 27.104,
    viewBox: "0 0 27.292 27.104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13852.829 -8566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.5,143.9a.975.975,0,0,0,.975.975h1.462a.487.487,0,0,1,.487.487V146.4l2.166-1.445h0a.492.492,0,0,1,.27-.082h8.285a.975.975,0,0,0,.975-.975V140H332.5Zm4.386-2.924h8.773v.975h-8.773Zm-1.949,0h.975v.975h-.975Zm-.975,1.949h11.7v.975h-11.7Z",
    transform: "translate(13533 8431.85)",
    fill: "#169cc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.2,272.225a.975.975,0,1,1-.975-.975.975.975,0,0,1,.975.975",
    transform: "translate(13656.94 8307.909)",
    fill: "#169cc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.146,332.87h-8.285a.492.492,0,0,1-.27-.082l-2.166-1.445v1.039a.487.487,0,0,1-.487.487h-1.462a.975.975,0,0,0-.975.975v4.874a.975.975,0,0,0,.975.975h12.672a.975.975,0,0,0,.975-.975v-4.874a.975.975,0,0,0-.975-.975Zm-3.412,1.949h.975v.975h-.975Zm-1.949,0h.975v.975h-.975ZM338,334.677l.689-.689.975.975h0a.488.488,0,0,1,0,.689l-.975.975-.689-.689.63-.63Zm-1.093-.986.926.308-.975,2.924-.926-.308Zm-1.974,5.028h-.975v-.975h.975Zm.832-2.782-.689.689-.975-.975h0a.488.488,0,0,1,0-.689l.975-.975.689.689-.63.63Zm9.89,2.782h-9.747v-.975h9.747Zm0-2.924h-.975v-.975h.975Z",
    transform: "translate(13533.001 8251.162)",
    fill: "#169cc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,62.218l9.26,3.087V41.477L105,38.39Zm6.336-11.833a1.949,1.949,0,1,1-1.379.571A1.95,1.95,0,0,1,111.336,50.385Z",
    transform: "translate(13747.829 8527.799)",
    fill: "#169cc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.266,52.058V50.6a.487.487,0,0,1,.758-.406l.7.47V48.1l-.7.47h0a.487.487,0,0,1-.758-.406V46.7h-.975a1.949,1.949,0,0,1-1.949-1.949V37.925a1.949,1.949,0,0,1,1.949-1.949h2.437V35H150.16l7.386,2.462a.488.488,0,0,1,.333.462V58.882h1.462V54.008a1.949,1.949,0,0,1,1.949-1.949Z",
    transform: "translate(13705.185 8530.999)",
    fill: "#169cc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.146,70H333.475a.975.975,0,0,0-.975.975v1.949h14.621V70.975a.975.975,0,0,0-.975-.975Zm-11.7,1.949h-.975v-.975h.975Zm1.949,0h-.975v-.975h.975Zm1.949,0h-.975v-.975h.975Z",
    transform: "translate(13533 8497.949)",
    fill: "#169cc5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackendIcon);
export default __webpack_public_path__ + "static/media/backend-icon.57bd53e11df1b4cfcec6d4911877a8e6.svg";
export { ForwardRef as ReactComponent };